import { restClient } from 'config/store/configureStore';
import { AUDIT_STATISTICS_REDUCE_URL } from 'constants/ApiConstants';

import { resolveLink } from '../UrlResolver';

export default {
  getAuditStatisticsForQuestion: (link, parameters = {}) => {
    const { url, params } = resolveLink(link, AUDIT_STATISTICS_REDUCE_URL, parameters);
    return restClient.get(url, { params });
  },
};
